// components/Header.tsx
import React from 'react'
import { Box, Typography } from '@mui/material'
import { useWizard } from 'react-use-wizard'
import { useTranslation } from 'react-i18next'

interface HeaderProps {
  title?: string // Optional title for the wizard
  steps: number // Total number of steps (passed from parent)
}

/**
 * Header component for the wizard, displaying a progress indicator with narrow lines.
 */
const StepHeader: React.FC<HeaderProps> = ({ title, steps }) => {
  const { activeStep } = useWizard()
  const { t } = useTranslation()

  return (
    <Box sx={{ mb: 2, textAlign: 'center' }}>
      {/* Optional Title */}
      {title && (
        <Typography variant="h5" sx={{ mb: 2 }}>
          {t(`QUIZ.${title}`)}
        </Typography>
      )}

      {/* Step Indicator */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 1, // Space between lines
          maxWidth: 400,
          mx: 'auto', // Center horizontally
        }}
      >
        {Array.from({ length: steps }, (_, index) => (
          <Box
            key={index}
            sx={{
              height: 4, // 4px height for narrow lines
              width: `${100 / steps}%`, // Equal width for each step
              backgroundColor:
                index <= activeStep ? 'success.main' : 'grey.300',
              borderRadius: 2, // Slight rounding for style
              transition: 'background-color 0.3s ease', // Smooth color transition
            }}
          />
        ))}
      </Box>

      {/* Optional Step Counter */}
      <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
        {t('QUIZ.step')} {activeStep + 1} {t('QUIZ.step_of_total')} {steps}
      </Typography>
    </Box>
  )
}

export default StepHeader
